import React from 'react';
import {Link} from 'react-router';
import {makeStyles} from '@material-ui/core/styles';
import ReCAPTCHA from 'react-google-recaptcha';
import {LoginErrorType} from 'stores/AuthStore.utils';

interface LoginErrorProps {
  loginError: LoginErrorType | null;
  siteKey: string | undefined;
  setCaptcha: (captcha: any) => void;
}

export const LoginError: React.FC<LoginErrorProps> = ({loginError, siteKey, setCaptcha}) => {
  const css = useStyles();

  if (loginError === null) {
    return null;
  }

  return (
    <div className={css.loginError}>
      {loginError === LoginErrorType.INVALID_CREDENTIALS && (
        <div className={css.message}>
          We didn't recognize your credentials. Please try again or{' '}
          <Link to={'/password/forgot'}>reset your password.</Link>
        </div>
      )}
      {loginError === LoginErrorType.NEEDS_SSO && (
        <div className={css.message}>
          Your account's normal sign-in flow has been disabled. Please contact your system admin to
          use SSO
        </div>
      )}
      {loginError === LoginErrorType.NEEDS_CAPTCHA &&
        (siteKey ? (
          <ReCAPTCHA className="captcha-container" sitekey={siteKey} onChange={setCaptcha} />
        ) : (
          'Captcha site key is not available. Please refresh the page'
        ))}
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  loginError: {
    marginBottom: 20,
    textAlign: 'center',
    color: theme.palette.error.main,
  },
  message: {
    marginBottom: 10,
  },
}));
